import { render, staticRenderFns } from "./ShowTab.vue?vue&type=template&id=66f68172&scoped=true&"
import script from "./ShowTab.vue?vue&type=script&lang=js&"
export * from "./ShowTab.vue?vue&type=script&lang=js&"
import style0 from "./ShowTab.vue?vue&type=style&index=0&id=66f68172&lang=less&scoped=true&"
import style1 from "./ShowTab.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f68172",
  null
  
)

export default component.exports